<template>
  <div class="learn-ability-test-result-card">
    <div class="learn-ability-test-result-card-painting-container"
         id="share-content-container"
    >
      <img class="learn-ability-test-result-card-header-img"
           :src="require('@/pages/2020/LearnAbilityTest/assets/img/card_header.png')"
      />
      <div class="learn-ability-test-result-card-container">
        <div class="learn-ability-test-result-card-main-content">
          <img class="learn-ability-test-result-card-main-content-img"
               :src="require('@/pages/2020/LearnAbilityTest/assets/img/card_content.png')"
          />
          <div class="learn-ability-test-result-card-radar-container">
            <div class="learn-ability-test-result-card-radar-title learn-ability-test-result-card-block-title">
              <div class="deco-block"></div>
              六大领域雷达图
            </div>
            <div class="learn-ability-test-result-card-radar-chart">
              <radar-chart :result-list="resultList" />
            </div>
            <div class="learn-ability-test-result-card-radar-desc">
              *根据雷达图，家长和孩子可以更合理的评估自己的学习策略，针对性加强自己较为不足的领域。
            </div>
          </div>
        </div>
        <div class="learn-ability-test-result-card-main-analyze">
          <div class="learn-ability-test-result-card-main-analyze-title learn-ability-test-result-card-block-title">
            <div class="deco-block"></div>
            测评解析
          </div>
          <div class="learn-ability-test-result-card-main-analyze-block">
            <div class="learn-ability-test-result-card-main-analyze-block-header">
              <div class="learn-ability-test-result-card-main-analyze-block-advantage-tip">优势</div>
              <div class="learn-ability-test-result-card-main-analyze-block-title">{{ advantage.title }}</div>
            </div>
            <div class="learn-ability-test-result-card-main-analyze-block-summary">{{ advantage.summary }}。</div>
          </div>
          <div class="learn-ability-test-result-card-main-analyze-block">
            <div class="learn-ability-test-result-card-main-analyze-block-header">
              <div class="learn-ability-test-result-card-main-analyze-block-dis-advantage-tip">{{ min === 5 ? '优势' : '不足' }}</div>
              <div class="learn-ability-test-result-card-main-analyze-block-title">{{ disAdvantage.title }}</div>
            </div>
            <div class="learn-ability-test-result-card-main-analyze-block-summary">{{ disAdvantage.summary }}。</div>
          </div>
        </div>
        <div class="learn-ability-test-result-card-footer-block">
          <div class="learn-ability-test-result-card-footer-block-info">
            <img class="learn-ability-test-result-card-footer-block-info-logo-img"
                 :src="require('@/pages/2020/LearnAbilityTest/assets/img/logo.png')"
            />
            <div class="learn-ability-test-result-card-footer-block-info-desc">
              <img class="learn-ability-test-result-card-footer-block-info-desc-img"
                   :src="require('@/pages/2020/LearnAbilityTest/assets/img/desc_bg.png')"
              />
              <span>测测您家孩子的自主学习力</span>
            </div>
          </div>
          <div class="learn-ability-test-result-card-footer-block-qr-code">
            <img class="learn-ability-test-result-card-footer-block-qr-code-img"
                 :src="require('@/pages/2020/LearnAbilityTest/assets/img/qr_code.png')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RadarChart from '@/components/RadarChart';
  import { htmlToCanvas, canvasToImage } from '@/utils/canvas';
  import validator from '@/utils/validator';

  export default {
    name: 'WishBottleResultCard',
    components: {
      RadarChart,
    },
    props: {
      userInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      resultList: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        analyze: [
          {
            blockTitle: '认知领域',
            list: [
              {
                title: '创造性',
                summary: '孩子有很不错的创造性思维习惯，遇到问题时，能从多角度去思考，积极寻找答案，不会受现有知识的限制',
              },
              {
                title: '好奇心',
                summary: '好奇心是创造性思维的开始，父母可以有意识的鼓励孩子观察，这样他会更愿意理解更深层次的的事物逻辑，学习积极性也会更高',
              },
            ],
          },
          {
            blockTitle: '动机情感领域',
            list: [
              {
                title: '自我激励',
                summary: '懂得自我激励的孩子，更关注自己在过程中的收获与进步，并且更容易向目标前进；在遇到不理想的环境和诱惑时仍能坚持达标',
              },
              {
                title: '情绪管理',
                summary: '孩子情绪反应大，容易被外界事物困扰继而影响学习。父母应该有意识帮助ta能管理情绪以完成任务，达成目标或控制自己行为',
              },
            ],
          },
          {
            blockTitle: '任务领域',
            list: [
              {
                title: '循序渐进',
                summary: '孩子有很好的目标感，懂得为自己合理安排各阶段的任务，这将帮助孩子在逐步进步中获得自信心，进一步增强学习动力，也对他未来有莫大的影响与受益',
              },
              {
                title: '自控能力',
                summary: '孩子的自控力不足，做事容易缺乏耐心，并被外界诱惑所影响。父母需要有意识培养孩子的自我控制和延迟满足感',
              },
            ],
          },
          {
            blockTitle: '环境领域',
            list: [
              {
                title: '注意力',
                summary: '孩子能够懂得注意力的重要性，并且有意识去让自身保持对事物的专注，这能让孩子更高效的学习，并且建立自信心',
              },
              {
                title: '专注力',
                summary: '孩子思维比较跳跃，专注力不强，容易影响学习效率。在平时的学习生活中，父母可以多给予孩子耐心，尽可能不要打断孩子的思路和注意力，并进行一些专注力训练',
              },
            ],
          },
          {
            blockTitle: '时间领域',
            list: [
              {
                title: '目标规划',
                summary: '孩子会合理的给自己制定目标并进行规划，这项能力将帮助他快速成长，并在一次次小的成功中获得自信心，建立正向反馈机制',
              },
              {
                title: '执行能力',
                summary: '孩子注意力不足，可能是执行功能较弱，这会让孩子容易收到外界干扰，并养成拖延磨蹭的习惯，导致任务无法完成',
              },
            ],
          },
          {
            blockTitle: '求助资源领域',
            list: [
              {
                title: '善于提问',
                summary: '孩子善于提出疑问，并且能够勇敢主动的需求外界的帮助，这些都能帮助他懂得在实践中体验和思考',
              },
              {
                title: '信息搜索',
                summary: '孩子需要掌握的，除了搜索的方法，还有建立分析解读和合理运用网络信息的思维习惯',
              },
            ],
          },
        ],
      };
    },
    computed: {
      max() {
        return Math.max.apply(null, this.resultList);
      },
      min() {
        return Math.min.apply(null, this.resultList);
      },
      advantage() {
        const index = this.resultList.findIndex(item => item === this.max);
        return this.analyze[index].list[0];
      },
      disAdvantage() {
        if (this.min === 5) return this.analyze[5].list[0];
        const index = this.resultList.findIndex(item => item === this.min);
        return this.analyze[index].list[1];
      },
      level() {
        const { resultList } = this;
        const sum = resultList.reduce((prev, current) => prev + current);
        if (sum > 20) return 'A';
        if (sum > 10) return 'B';
        return 'C';
      },
    },
    methods: {
      generateImage() {
        return new Promise(async (resolve, reject) => {
          try {
            const $certificate = document.getElementById('share-content-container');
            const canvas = await htmlToCanvas($certificate, {
              x: 0,
              y: 0,
              backgroundColor: null,
              scale: 3,
            });
            const img = canvasToImage(canvas);
            return resolve(img);
          } catch (e) {
            return reject(e);
          }
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .learn-ability-test-result-card {
    width: 750px;
    height: 1750px;

    &-result-container {
      width: 750px;
      height: 1750px;
      /deep/ img {
        display: inline-block;
        width: 750px;
      }
    }

    &-painting-container {
      position: relative;
      box-sizing: border-box;
      width: 750px;
      height: 1750px;
      z-index: 0;
      padding-top: 30px;
      background: #232548;
    }

    &-header-img {
      display: block;
      margin-bottom: -62px;
      width: 750px;
      height: 238px;
    }

    &-main-content {
      position: relative;
      width: 750px;
      height: 813px;
    }
    &-main-content-img {
      width: 750px;
      height: 813px;
    }
    &-user-name {
      position: absolute;
      top: 48px;
      left: 178px;
      color: #222;
      font-size: 48px;
      font-weight: bold;
      line-height: 1;
    }
    &-user-age {
      position: absolute;
      top: 124px;
      left: 178px;
      color: #222;
      font-size: 36px;
      font-weight: bold;
      line-height: 1;
    }
    &-learn-level {
      position: absolute;
      top: 40px;
      right: 90px;
      width: 160px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-title {
        color: #7d7e8f;
        font-size: 32px;
        line-height: 1;
        word-break: keep-all;
      }
      &-number {
        margin-top: 12px;
        color: #3c3cd9;
        font-size: 90px;
        font-weight: bold;
        line-height: 1;
      }
    }

    &-block-title {
      box-sizing: border-box;
      display: flex;
      color: #222;
      font-size: 40px;
      font-weight: bold;
      line-height: 1;

      .deco-block {
        margin: 1px 14px 0 0;
        content: '';
        width: 10px;
        height: 36px;
        background: #3c3cd9;
        border-radius: 5px;
      }
    }

    &-radar {
      &-container {
        box-sizing: border-box;
        position: absolute;
        top: 52px;
        left: 0;
        padding-left: 70px;
      }
      &-chart {
        width: 610px;
        height: 566px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &-desc {
        padding-right: 80px;
        color: #6d6d7e;
        font-size: 20px;
        line-height: 1.6;
      }
    }

    &-main-analyze {
      box-sizing: border-box;
      width: 690px;
      padding: 0 40px 70px 40px;
      margin: -1px auto 0;
      background: @color-white;
      border-radius: 0 0 50px 50px;

      &-title {
        margin-bottom: 44px;
      }

      &-block {
        &:not(:last-child) {
          margin-bottom: 56px;
        }
        &-header {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        &-advantage-tip {
          margin-right: 10px;
          width: 60px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #7474a0;
          font-size: 22px;
          line-height: 1;
          background: #eaeaff;
          border-radius: 4px;
        }
        &-dis-advantage-tip {
          margin-right: 10px;
          width: 60px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #d08498;
          font-size: 22px;
          line-height: 1;
          background: #ffeeee;
          border-radius: 4px;
        }
        &-title {
          color: #222;
          font-size: 32px;
          line-height: 1;
          font-weight: bold;
        }
        &-summary {
          color: #787878;
          font-size: 22px;
          line-height: 1.4;
        }
      }
    }

    &-footer-block {
      box-sizing: border-box;
      height: 270px;
      padding: 45px 100px 64px 85px;
      display: flex;
      align-items: flex-end;

      &-info {
        box-sizing: border-box;
        width: 390px;
        margin-right: 24px;
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &-logo-img {
          margin-bottom: 20px;
          display: flex;
          width: 254px;
          height: 80px;
        }
        &-desc {
          position: relative;
          width: 390px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #242648;
          font-size: 28px;
          line-height: 1;

          img {
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 390px;
            height: 50px;
            z-index: 0;
          }
          span {
            position: relative;
            z-index: 1;
          }
        }
      }
      &-qr-code {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: @color-white;
        border-radius: 15px;

        &-img {
          display: block;
          width: 130px;
          height: 130px;
        }
      }
    }
  }

</style>
